import Box from '@mui/material/Box'
import { Link, Typography } from '@mui/material'
import { WindowsIconLarge } from 'assets'
import ZendeskLink from 'components/Common/ZendeskLink'

import './index.css'

let sx = {
  container: {
    backgroundColor: '#F2F8FC',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center horizontally
    justifyContent: 'center', // Center vertically
    textAlign: 'center',
    padding: '40px 30px', // Padding values adjusted
  },

  windowsIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme => theme.palette.common.white,
    height: '100px',
    width: '100px',
    borderRadius: '100%',
  },
}

const MobileCheck = () => {
  return (
    <Box sx={sx.container} className="MobileCheck">
      <Typography variant="h6" sx={{ color: theme => theme.palette.color.blue, marginBottom: '20px' }}>
        The Markaaz Dashboard is better on desktop!
      </Typography>
      <Box sx={sx.windowsIconContainer}>
        <WindowsIconLarge />
      </Box>
      <Typography variant="body2" sx={{ color: theme => theme.palette.color.darkBlue70, margin: '20px' }}>
        We're currently optimizing our mobile experience. Please use the URL below to access the full features of the
        Markaaz Dashboard on your desktop.
      </Typography>
      <Link
        rel="noreferrer"
        href={process.env['REACT_APP_DASHBOARD_LINK']}
        color="secondary"
        underline="hover"
        style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '20px' }}
      >
        {process.env['REACT_APP_DASHBOARD_LINK'].replace(/^https?:\/\//, '')}
      </Link>
      <ZendeskLink />
    </Box>
  )
}
export default MobileCheck
